var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-container"},[_c('div',{staticClass:"inquiry"},[_c('div',{staticClass:"title"},[_vm._v("我要查询")]),_c('inquiry-tool')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }